import { Collapse as AntCollapse } from 'antd';
import type { CollapseProps } from 'antd';

export interface DCollapseProps extends CollapseProps {}

export const DarwinCollapse = (props: DCollapseProps) => {
  return <AntCollapse {...props} />;
};

DarwinCollapse.Panel = AntCollapse.Panel;
